import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_DOCUMENT_PROOF',
  name: 'Workspace Project Document Proof',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: '_fileId', title: 'File' },
    { key: 'name', title: 'Name' },
    { key: 'documentType', title: 'Document Type' },
    { key: 'status', title: 'Status' },
    { key: 'featured', title: 'Featured' },
    { key: 'knowledgeBase', title: 'Knowledge Base' },
  ],
  actions: ['READ', 'CREATE', 'UPDATE', 'UPLOAD', 'DESTROY'],
}

export default scope
